/**
 * The first question every Netly Pay screen asks: is this shop linked?
 *
 * `not_linked` is a STATE and not an error — it means the shop has not set
 * Netly Pay up, and the honest answer is the Enable screen rather than a
 * failure message (D54). Four screens need exactly this gate, so it lives
 * here instead of being copied into each of them.
 */
import React from 'react';
import {ErrorState, Skeleton} from './States';
import type {UseLink} from '../hooks/useNetlyPay';
import EnableNetlyPayView from '../views/EnableNetlyPayView';

export const ScreenGate = ({
  link,
  shopId,
  shop,
  children,
}: {
  link: UseLink;
  shopId?: string | null;
  shop: any;
  children: React.ReactNode;
}) => {
  if (link.phase === 'loading') {
    return (
      <div className="p-7">
        <div className="bg-surface border border-borderc rounded-card">
          <Skeleton rows={5} />
        </div>
      </div>
    );
  }

  if (link.phase === 'error') {
    return (
      <div className="p-7">
        <div className="bg-surface border border-borderc rounded-card">
          <ErrorState message={link.error} onRetry={link.reload} />
        </div>
      </div>
    );
  }

  if (link.phase === 'not_linked') {
    return (
      <div className="p-7">
        <EnableNetlyPayView shopId={shopId ?? ''} shop={shop} onEnabled={link.reload} />
      </div>
    );
  }

  return <>{children}</>;
};

/** The bottom-centre toast the Netly Pay screens use for "Reminder sent". */
export const Toast = ({message}: {message: string}) => (
  <div
    role="status"
    className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[70] px-4 py-2.5 rounded-xl bg-text1 text-surface text-[13px] font-medium"
    style={{boxShadow: '0 12px 32px rgba(15,15,26,.24)'}}
  >
    {message}
  </div>
);

export default ScreenGate;
